document.addEventListener("DOMContentLoaded", ()=> {
  initializeModalTermosECondicoes();
  initializeSubmitSpinner();
});

function initializeModalTermosECondicoes() {
  $("#open-termos-de-uso").on("click", (ev)=> {
    ev.preventDefault();

    $("#modal-termos-de-uso").modal({
      show: true,
      backdrop: "static",
      keyboard: false,
    });
  });
}

function initializeSubmitSpinner() {
  $("#new_cadastro").on("submit", function () {
    $(this).addClass("hide");
    $(".register-title").text(
      `${window.t("interface.maino_flex.auto_cadastro.loading_user_create")}...`,
    );
    $(".register-title").parent().addClass("justify-content-center");
    $("#spinner-section").removeClass("hide");
  });
}
